import React, { type ChangeEvent, useState, type FC } from 'react'
import { type ProgramExpenseMultiplierInputProps } from '../utils/types'
import GenericInputBox from '../../../components/generic-input-box'

const ProgramExpenseMultiplierInput: FC<ProgramExpenseMultiplierInputProps> = ({
  initialValue,
  onChange
}) => {
  const [currentValue, setCurrentValue] = useState(initialValue)
  const [overrideDefault, setOverrideDefault] = useState(false)
  const [error, setError] = useState('')

  const handleInputChange = (value: string | number) => {
    const numericValue = typeof value === 'string'
      ? parseFloat(value.replace(/[^\d.]/g, ''))
      : value

    if (isNaN(numericValue)) {
      setError('Please enter a valid number')
      return
    }

    if (numericValue > 100) {
      setError('Cannot exceed 100%')
      setCurrentValue(100)
      onChange(100, overrideDefault)
    } else if (numericValue < 0) {
      setError('Cannot be negative')
      setCurrentValue(0)
      onChange(0, overrideDefault)
    } else {
      setError('')
      setCurrentValue(numericValue)
      onChange(numericValue, overrideDefault)
    }
  }

  const handleCheckboxChange = (e: ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked
    setOverrideDefault(isChecked)
    onChange(currentValue, isChecked)
  }

  return (
    <div className="flex flex-col space-y-2">
      <div className="flex items-center space-x-2">
        <label className="font-bold">Program Expense Multiplier:</label>
        <div className="flex flex-col">
          {error && (
            <div className="text-red-500 text-sm">
              {error}
            </div>
          )}
          <GenericInputBox
            name="programExpenseMultiplier"
            type="text"
            value={currentValue}
            isNumeric
            onChange={handleInputChange}
            className={`text-right rounded-md border-gray-300 shadow-sm focus:ring-gray-100 focus:border-gray-300 max-w-[80px] min-w-[40px] w-auto ${
              error ? 'border-red-500' : ''
            }`}
          />
        </div>
        <span>%</span>
        <label className="flex items-center space-x-2">
          <input
            type="checkbox"
            checked={overrideDefault}
            onChange={handleCheckboxChange}
            className="form-checkbox h-4 w-4 text-gray-600 transition duration-150 ease-in-out"
          />
          <span className="text-sm">Override Program Default</span>
        </label>
      </div>
    </div>
  )
}

export default ProgramExpenseMultiplierInput
